module.exports = import("https://cdn.skypack.dev/jspdf@2.5.1");;